// @ts-nocheck
import { RESET_SLICE_ONE_ON_ONE_MESSAGING } from "../constants/messagingCommon";
import { 
  CHAT_ROOMS_FAILURE, CHAT_ROOMS_LOADING, CHAT_ROOMS_SUCCESS, 
  FETCH_CHAT_ROOM_MESSAGES_FAILURE, FETCH_CHAT_ROOM_MESSAGES_LOADING, 
  FETCH_CHAT_ROOM_MESSAGES_SUCCESS, 
  ON_SELECT_NEW_CHAT_ROOM, 
  SEND_NEW_MESSAGE_FAILURE, 
  SEND_NEW_MESSAGE_LOADING,
  SEND_NEW_MESSAGE_SUCCESS,
  ADD_NEW_CHAT_ROOM_PARTICIPANT,
  ADD_NEW_CHAT_ROOM_LOADING,
  ADD_NEW_CHAT_ROOM_SUCCESS,
  ADD_NEW_CHAT_ROOM_FAILURE,
  SETUP_LOADING,
  SETUP_SUCCESS,
  SETUP_FAILURE,
  ON_DELETE_MESSAGE,
  ON_EDIT_MESSAGE,
  EDIT_NEW_MESSAGE_LOADING,
  EDIT_NEW_MESSAGE_SUCCESS,
  EDIT_NEW_MESSAGE_FAILURE,
  MESSAGE_CONTAINER_SCROLL,
  ON_NEW_MESSAGE_ONE_ON_ONE_CHAT,
  ON_MARK_MESSAGES_AS_READ,
  SET_UNREAD_ONE_ON_ONE_CHAT_ROOMS_COUNT
} from "../constants/oneononemessaging";
import { store } from "../store";

const initialState = {
  messagingContainerScroll: {
    update: 0
  },
  setup: {
    isLoading: false,
    success: false,
    failure: false
  },
  chatRooms: {
    data: [],
    isLoading: false
  },
  selectedChatRoom: {
    data: null
  },
  chatRoomMessages: {
    data: [],
    chatId: "",
    isLoading: false
  },
  unreadChatRoomsCount: {
    data: {
      oneOnOneCount: null,
    },
    isLoading: false
  },
  newChatRoom: {
    isLoading: false
  },
  newMessage: {
    isLoading: false
  },
  editMessage: {
    isLoading: false
  }
};

const oneOnOneMessagingReducer = (state = initialState, action) => {
  switch (action?.type) {

    case MESSAGE_CONTAINER_SCROLL: {
      return {
        ...state,
        messagingContainerScroll: {
          ...state?.messagingContainerScroll,
          update: (state?.messagingContainerScroll?.update + 1) % 10
        }
      }
    }

    case SETUP_LOADING: {
      return {
        ...state,
        setup: {
          ...state.setup,
          success: false,
          failure: false,
          isLoading: true,
        }
      }
    }   
    
    case SETUP_SUCCESS: {
      return {
        ...state,
        setup: {
          ...state.setup,
          success: true,
          failure: false,
          isLoading: false,
        }
      }
    }   


    case SETUP_FAILURE: {
      return {
        ...state,
        setup: {
          ...state.setup,
          success: false,
          failure: true,
          isLoading: false,
        }
      }
    }   

    case CHAT_ROOMS_LOADING:
      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          isLoading: true
        }
      };

    case CHAT_ROOMS_SUCCESS:
      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: action?.payload?.chatRooms,
          isLoading: false
        }
      };

    case CHAT_ROOMS_FAILURE:
      return {
        ...state,
        chatRooms: {
          ...initialState?.chatRooms
        }
      };

    case FETCH_CHAT_ROOM_MESSAGES_LOADING:
      return {
        ...state,
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          isLoading: true
        }
      };

    case FETCH_CHAT_ROOM_MESSAGES_SUCCESS: {
      let isOfSelectedChatRoom = false;
      let updatedChatRoomMessages = [...(state?.chatRoomMessages?.data || [])];
      if (action?.payload?.chatRoomMessages?.[0]?.chatId === state?.selectedChatRoom?.data?._id) {
        updatedChatRoomMessages = [...(action?.payload?.chatRoomMessages || [])];
        isOfSelectedChatRoom = true;
      }
      
      return {
        ...state,
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          data: updatedChatRoomMessages,
          chatId: isOfSelectedChatRoom ? action?.payload?.chatRoomMessages?.[0]?.chatId : state?.chatRoomMessages?.chatId,
          isLoading: false
        }
      };
    }

    case FETCH_CHAT_ROOM_MESSAGES_FAILURE:
      return {
        ...state,
        chatRoomMessages: {
          ...initialState?.chatRoomMessages
        }
      };

    case SET_UNREAD_ONE_ON_ONE_CHAT_ROOMS_COUNT: {
      return {
        ...state,
        unreadChatRoomsCount: {
          ...state.unreadChatRoomsCount,
          data: {
            ...state.unreadChatRoomsCount.data,
            oneOnOneCount: action?.payload?.oneOnOneCount
          }
        }
      }
    }

    case ON_MARK_MESSAGES_AS_READ: {

      let updatedChatRoomMessages = [...state.chatRoomMessages.data];
      let updatedChatRooms = [...state.chatRooms.data];
      let unreadMsgChatRoomsCount = {
        oneOnOneCount: 0
      }

      if (action?.payload?.chatRoomMessages?.[0]?.chatId !== state?.chatRoomMessages?.chatId) {
        for (let i = 0; i < action?.payload?.chatRoomMessages?.length; i++) {
          updatedChatRoomMessages = state?.chatRoomMessages?.data?.map(message => {
            if (action?.payload?.chatRoomMessages?.[i]?._id === message?._id) {
              return action?.payload?.chatRoomMessages?.[i]
            } else {
              return message;
            }
          });
        }
      }

      updatedChatRooms = updatedChatRooms?.map(chatRoom => {
        if (action?.payload?.chatRoomMessages?.[0]?.chatId === chatRoom?._id) {
          return {
            ...chatRoom,
            participants: chatRoom?.participants?.map?.(participant => {
              if (participant?.userId === action?.payload?.auth?.userId) {
                return {
                  ...participant,
                  unreadMsgCount: 0
                }
              } else {
                return participant;
              }
            })
          }
        } else {
          for (let i = 0; i < chatRoom?.participants?.length; i++) {
            if (chatRoom?.participants?.[i]?.userId === action?.payload?.auth?.userId &&
              chatRoom?.participants?.[i]?.unreadMsgCount > 0
            ) {
              unreadMsgChatRoomsCount.oneOnOneCount += 1;
              break;
            }
          }
          return chatRoom;
        }
      })

      return {
        ...state,
        chatRooms: {
          ...state.chatRooms,
          data: updatedChatRooms
        },
        chatRoomMessages: {
          ...state.chatRoomMessages,
          data: updatedChatRoomMessages
        },
        selectedChatRoom: {
          ...state.selectedChatRoom,
          data: updatedChatRooms?.find(chatRoom => {
            return (chatRoom?._id === state?.selectedChatRoom?.data?._id);
          }) || state?.selectedChatRoom?.data
        },
        unreadChatRoomsCount: {
          ...state?.unreadChatRoomsCount,
          data: {
            ...state.unreadChatRoomsCount?.data,
            ...unreadMsgChatRoomsCount
          }
        }
      }
    }

    case ADD_NEW_CHAT_ROOM_LOADING: {
      return {
        ...state,
        newChatRoom: {
          ...state?.newChatRoom,
          isLoading: true
        }
      }
    }

    case ADD_NEW_CHAT_ROOM_SUCCESS: {
      return {
        ...state,
        newChatRoom: {
          ...state?.newChatRoom,
          isLoading: false
        },
        chatRooms: {
          ...state?.chatRooms,
          data: [action?.payload?.newChatRoom, ...(state?.chatRooms?.data || [])],
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data: state?.selectedChatRoom?.data?.new ? action?.payload?.newChatRoom : state?.selectedChatRoom?.data
        }
        // chatRoomMessages: {
        //   ...state?.chatRoomMessages,
        //   data: [...(state?.chatRoomMessages?.data || []), action?.payload?.newChatRoom?.latestMessage],
        //   chatId: state?.chatRoomMessages.data?.[0]?.chatId || action?.payload?.newChatRoom?.latestMessage?.chatId
        // }
      }
    }

    case ADD_NEW_CHAT_ROOM_FAILURE: {
      return {
        ...state,
        newChatRoom: {
          ...state?.newChatRoom,
          isLoading: false
        }
      }
    }

    case ADD_NEW_CHAT_ROOM_PARTICIPANT: {

      let unreadMsgChatRoomsCount = {
        oneOnOneCount: 0
      }

      const updatedChatRooms = [
        {
          ...action?.payload?.newChatRoom,
          participants: action?.payload?.newChatRoom?.participants?.map?.(participant => {
            return {
              ...participant,
              unreadMsgCount: participant?.unreadMsgCount >= 0 ? participant?.unreadMsgCount : 1
            }
          })
        },
        ...(state?.chatRooms?.data || [])
      ];

      for (let i = 0; i < updatedChatRooms?.length; i++) {
        for (let i = 0; i < updatedChatRooms?.[i]?.participants?.length; i++) {
          if (updatedChatRooms?.[i]?.participants?.[i]?.userId === store?.getState()?.auth?.userId &&
            updatedChatRooms?.[i]?.participants?.[i]?.unreadMsgCount > 0
          ) {
            unreadMsgChatRoomsCount.oneOnOneCount += 1;
            break;
          }
        }
      }

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: updatedChatRooms,
        },
        unreadChatRoomsCount: {
          ...state.unreadChatRoomsCount,
          data: {
            ...state.unreadChatRoomsCount,
            ...unreadMsgChatRoomsCount
          }
        }
      }
    }

    case SEND_NEW_MESSAGE_LOADING:
      return {
        ...state,
        newMessage: {
          ...state?.newMessage,
          isLoading: true
        }
      };

    case SEND_NEW_MESSAGE_SUCCESS:
      return {
        ...state,
        newMessage: {
          ...state?.newMessage,
          isLoading: false
        }
      };

    case SEND_NEW_MESSAGE_FAILURE:
      return {
        ...state,
        newMessage: {
          ...initialState?.newMessage,
        }
      };

    case EDIT_NEW_MESSAGE_LOADING:
      return {
        ...state,
        editMessage: {
          ...state?.editMessage,
          isLoading: true
        }
      };

    case EDIT_NEW_MESSAGE_SUCCESS:
      return {
        ...state,
        editMessage: {
          ...state?.editMessage,
          isLoading: false
        }
      };

    case EDIT_NEW_MESSAGE_FAILURE:
      return {
        ...state,
        editMessage: {
          ...initialState?.editMessage,
        }
      };

    case ON_NEW_MESSAGE_ONE_ON_ONE_CHAT: {
      let isNewMessageOfActiveChatRoom = false;
      let chatRoomsArrCpy = [...state.chatRooms.data];
      let unreadMsgChatRoomsCount = {
        oneOnOneCount: 0
      }

      if (state?.selectedChatRoom?.data?._id === action?.payload?.newMessage?.chatId) {
        isNewMessageOfActiveChatRoom = true;
      }

      const newMessageChatRoom = chatRoomsArrCpy?.find(chatRoom => {
        return (chatRoom?._id === action?.payload?.newMessage?.chatId);
      });

      const newMessageChatRoomIdx = chatRoomsArrCpy?.findIndex(chatRoom => {
        return (chatRoom?._id === action?.payload?.newMessage?.chatId);
      });

      for (let i = newMessageChatRoomIdx - 1; i >= 0; i--) {
        chatRoomsArrCpy[i + 1] = chatRoomsArrCpy[i];
      }

      chatRoomsArrCpy[0] = {
        ...newMessageChatRoom,
        latestMessage: action?.payload?.newMessage
      };

      if (!isNewMessageOfActiveChatRoom) {
        chatRoomsArrCpy = chatRoomsArrCpy?.map(chatRoom => {
          if (chatRoom?._id === action?.payload?.newMessage?.chatId) {
            return {
              ...chatRoom,
              participants: chatRoom?.participants?.map?.(participant => {
                if (participant?.userId === action?.payload?.auth?.userId) {
                  return {
                    ...participant,
                    unreadMsgCount: participant?.unreadMsgCount >= 0 ? participant?.unreadMsgCount + 1 : 1
                  }
                } else {
                  return participant;
                }
              })
            }
          } else {
            return chatRoom;
          }
        })
      }

      for (let i = 0; i < chatRoomsArrCpy?.length; i++) {
        for (let j = 0; j < chatRoomsArrCpy?.[i]?.participants?.length; j++) {
          if (chatRoomsArrCpy?.[i]?.participants?.[j]?.userId === action?.payload?.auth?.userId && 
            chatRoomsArrCpy?.[i]?.participants?.[j]?.unreadMsgCount > 0
          ) {
            unreadMsgChatRoomsCount.oneOnOneCount += 1;
          }
        }
      }

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: chatRoomsArrCpy
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          data: action?.payload?.newMessage?.chatId === state?.chatRoomMessages?.chatId ? (
            [...(state?.chatRoomMessages?.data || []), action?.payload?.newMessage]
          ) : [...(state?.chatRoomMessages?.data || [])],
          // chatId: state?.chatRoomMessages?.data?.[0]?.chatId || action?.payload?.newMessage?.chatId,
          isLoading: false
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data: chatRoomsArrCpy?.find(chatRoom => {
            return (chatRoom?._id === state?.selectedChatRoom?.data?._id);
          }) || state?.selectedChatRoom?.data
        },
        unreadChatRoomsCount: {
          ...state?.unreadChatRoomsCount,
          data: {
            ...state?.unreadChatRoomsCount?.data,
            ...unreadMsgChatRoomsCount
          }
        }
      };
    }

    case ON_EDIT_MESSAGE: {
      let chatRoomsArrCpy = [...state.chatRooms.data];
      let filteredChatRoomMessages = [];

      if (action?.payload?.editedMessage?.chatId !== (state?.chatRoomMessages?.data?.[0]?.chatId || state?.chatRoomMessages?.chatId)) {
        filteredChatRoomMessages = [...(state?.chatRoomMessages?.data || [])];
      } else {
        filteredChatRoomMessages = state?.chatRoomMessages?.data?.map(chatRoomMessage => {
          if (chatRoomMessage?._id === action?.payload?.editedMessage?._id) {
            return {
              ...action?.payload?.editedMessage
            }
          } else {
            return chatRoomMessage
          }
        });
      }


      chatRoomsArrCpy = chatRoomsArrCpy?.map((chatRoom, chatRoomIdx) => {
        if (chatRoom?._id === action?.payload?.editedMessage?.chatId && 
          chatRoom?.latestMessage?._id === action?.payload?.editedMessage?._id) {
          return {
            ...chatRoom,
            latestMessage: action?.payload?.editedMessage
          }
        } else {
          return chatRoom;
        }
      });

      const newMessageChatRoom = chatRoomsArrCpy?.find(chatRoom => {
        return (chatRoom?._id === action?.payload?.editedMessage?.chatId);
      });

      const newMessageChatRoomIdx = chatRoomsArrCpy?.findIndex(chatRoom => {
        return (chatRoom?._id === action?.payload?.editedMessage?.chatId);
      });

      if (newMessageChatRoomIdx >= 0) {
        for (let i = newMessageChatRoomIdx - 1; i >= 0; i--) {
          chatRoomsArrCpy[i + 1] = chatRoomsArrCpy[i];
        }
  
        chatRoomsArrCpy[0] = {
          ...newMessageChatRoom,
        };
      }

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: chatRoomsArrCpy
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          // data: action?.payload?.editedMessage?.chatId !== state?.chatRoomMessages?.data?.[0]?.chatId ? (
          //   [...(state?.chatRoomMessages?.data || [])]
          // ) : state?.chatRoomMessages?.data?.filter(chatRoomMessage => {
          //   return (chatRoomMessage?._id !== action?.payload?.editedMessage?._id);
          // }),
          data: [...(filteredChatRoomMessages || [])],
          // chatId: filteredChatRoomMessages?.[0]?.chatId || state?.chatRoomMessages?.chatId,
          isLoading: false
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data: chatRoomsArrCpy?.find(chatRoom => {
            return (chatRoom?._id === state?.selectedChatRoom?.data?._id);
          }) || state?.selectedChatRoom?.data
        }
      };
    }

    case ON_DELETE_MESSAGE: {
      let chatRoomsArrCpy = [...state.chatRooms.data];
      let filteredChatRoomMessages = [];

      if (action?.payload?.deletedMessage?.chatId !== (state?.chatRoomMessages?.data?.[0]?.chatId || state?.chatRoomMessages?.chatId)) {
        filteredChatRoomMessages = [...(state?.chatRoomMessages?.data || [])];
      } else {
        filteredChatRoomMessages = state?.chatRoomMessages?.data?.filter(chatRoomMessage => {
          return (chatRoomMessage?._id !== action?.payload?.deletedMessage?._id);
        });
      }

      const deletedMessageChatRoomIdx = chatRoomsArrCpy?.findIndex(chatRoom => {
        return (chatRoom?._id === action?.payload?.deletedMessage?.chatId);
      });

      const sortedChatRoomMessages = [...(filteredChatRoomMessages || [])]?.sort((a, b) => {
        const aDate = new Date(a.timestamp);
        const bDate = new Date(b.timestamp);
        if (aDate < bDate){
          return -1;
        }
        if (aDate > bDate){
          return 1;
        }
        return 0;
      });

      if (deletedMessageChatRoomIdx >= 0) {
        chatRoomsArrCpy = chatRoomsArrCpy?.map((chatRoom, chatRoomIdx) => {
          if (chatRoomIdx === deletedMessageChatRoomIdx) {
            return {
              ...chatRoom,
              latestMessage: sortedChatRoomMessages?.[sortedChatRoomMessages?.length - 1]
            }
          } else {
            return chatRoom;
          }
        });
      }

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: chatRoomsArrCpy
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          // data: action?.payload?.deletedMessage?.chatId !== state?.chatRoomMessages?.data?.[0]?.chatId ? (
          //   [...(state?.chatRoomMessages?.data || [])]
          // ) : state?.chatRoomMessages?.data?.filter(chatRoomMessage => {
          //   return (chatRoomMessage?._id !== action?.payload?.deletedMessage?._id);
          // }),
          data: [...(filteredChatRoomMessages || [])],
          // chatId: filteredChatRoomMessages?.[0]?.chatId || state?.chatRoomMessages?.chatId,
          isLoading: false
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data: chatRoomsArrCpy?.find(chatRoom => {
            return (chatRoom?._id === state?.selectedChatRoom?.data?._id);
          }) || state?.selectedChatRoom?.data
        }
      };
    }
      

    case ON_SELECT_NEW_CHAT_ROOM:
      return {
        ...state,
        chatRoomMessages: {
          ...initialState.chatRoomMessages,
          chatId: action?.payload?.chatRoom?.new ? "" : action?.payload?.chatRoom?._id
        },
        newMessage: {
          ...initialState.newMessage
        },
        selectedChatRoom: {
          ...state.selectedChatRoom,
          data: action?.payload?.chatRoom
        }
      };

    case RESET_SLICE_ONE_ON_ONE_MESSAGING: {
      return {
        ...state,
        selectedChatRoom: {
          ...initialState.selectedChatRoom
        },
        chatRoomMessages: {
          ...initialState.chatRoomMessages
        }
      }
    }

    default:
      return state;
  }
};

export default oneOnOneMessagingReducer;
export {
  initialState
}